import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';
import { Moedas } from 'src/app/domain/constants/moeda.constant';
import { InboundOrderDto } from 'src/app/domain/models/dto/inbound-order.dto';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { ExchangeInfoConfirmComponent } from '../exchange-info-confirm/exchange-info-confirm.component';
import { Subject, takeUntil } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-execution-order',
  templateUrl: './execution-order.component.html',
  styleUrls: ['./execution-order.component.scss'],
})
export class ExecutionOrderComponent implements OnInit {
  boobleModalData: any;
  currency: any;
  moedas = Moedas;
  rType: string = '';
  isLoading = false;

  iof: number;
  ir: number;
  commercial: number;

  private readonly notifier: NotifierService;
  public loading: boolean;
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private modalService: BoobleModalService,
    private readonly ordersService: OrdersService,
    notifierService: NotifierService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {
    this.rType = this.router.url.includes('0') ? '0' : '1';
    if (typeof this.boobleModalData === 'number') {
      this.loading = true;
      this.ordersService
        .getOrderById(this.boobleModalData, "true")
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (result) => {
            this.loading = false;
            this.boobleModalData = result.data;
            this.initializeComponent();
          },
          error: (err) => {
            this.loading = false;
          },
        });
    } else {
      this.initializeComponent();
    }
  }

  initializeComponent() {
    this.currency = this.moedas.find(
      (moeda) => moeda.id === this.boobleModalData.currency.id
    );

    if (this.boobleModalData.quotations?.length > 0) {
      const quotation = this.boobleModalData.quotations[0];
      if (this.boobleModalData.remmitanceType === 'OUTBOUND') {
        this.ir = quotation.irOutbound;
        this.iof = quotation.iofOutbound;
        this.commercial = Number(
          (quotation.rate + quotation.rate * quotation.spread).toPrecision(5)
        );
      } else if (this.boobleModalData.remmitanceType === 'INBOUND') {
        this.ir = quotation.irInbound;
        this.iof = quotation.iofInboud;
        this.commercial = Number(
          (quotation.rate - quotation.rate * quotation.spread).toPrecision(5)
        );
      }
    }
  }

  increasePercentage(value: number, percentage: number) {
    return value + value * percentage;
  }

  getIr(rate: number, spread: number, taxIr: number, ptax: number) {
    const residualIr =
      ((this.increasePercentage(rate, spread) < ptax
        ? ptax
        : this.increasePercentage(rate, spread)) *
        this.boobleModalData.amount) /
      (1 - taxIr);
    return residualIr * taxIr;
  }

  effectivateOrder(order: InboundOrderDto) {
    this.isLoading = true;
    this.ordersService.effectivateOrder(order.id).subscribe({
      next: (value) => {
        this.notifier.notify(
          'success',
          `Ordem efetivada com sucesso e contrato enviado.`
        );
        this.ordersService.updateOrderView();
        this.closeModal();
        this.isLoading = false;
      },
      error: (err) => (this.isLoading = false),
    });
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  openExchangeInfoConfirmModal(order: InboundOrderDto) {
    this.modalService.present(ExchangeInfoConfirmComponent, order);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
